/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { budgetsApiKeyEvents } from "../../funcs/budgetsApiKeyEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListApiKeyBudgetEventsRequest$inboundSchema,
};

export const tool$budgetsApiKeyEvents: ToolDefinition<typeof args> = {
  name: "budgets-api-key-events",
  description: `List apikey budget events

Returns recent threshold-alert and block events for the apikey's budgets. Callable by cluster admins, or org admins for API keys in their own organization.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await budgetsApiKeyEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
